import { FC, ReactNode } from 'react';
import { MenuList as MUIMenuList, MenuListProps } from '@mui/material';

export type AppMenuListProps = MenuListProps & {
  children?: ReactNode;
};

export const MenuList: FC<AppMenuListProps> = ({ children, ...props }) => {
  return <MUIMenuList {...props}>{children}</MUIMenuList>;
};
